import { useEffect, useRef, useState } from 'react';
import css from './index.module.scss';
import { useCountUp } from './useCountUp';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';

const I: React.FC = () => {
    const { t } = useLang('ats.I');
    const { locale = '' } = useRouter();
    const [enter, setEnter] = useState(false);
    const sectionRef = useRef<HTMLDivElement>(null);
    const screenRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const screen = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 0,
            offset: '0%',
            duration: window.innerHeight * 1.1,
            onProcess: (process: number) => {
                if (process <= 0) {
                    setEnter(false);
                }
            },
            onEnter: () => {
                setEnter(true);
            },
        });
        return () => {
            screen.destroy?.();
        };
    }, []);

    const { curNumber, run, reset } = useCountUp({ number: locale === 'ca' ? 4000 : 6000, time: locale === 'ca' ? 800 : 1200 });
    useEffect(() => {
        if (enter) {
            run();
        } else {
            reset();
        }
    }, [enter]);

    /** 动画 */
    useEffect(() => {
        const title = document?.querySelector('.smart-gateway-I .title');
        const desc = document?.querySelector('.smart-gateway-I .desc');
        const info = document?.querySelector('.smart-gateway-I .info');
        const ani1 = AniContainer.create({
            triggerElement: '.smart-gateway-I .title',
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                desc?.classList.add('enter');
                info?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    info?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <section
            className={`${css.section} smart-gateway-I GtmModuleData-section`}
            id="smart-gateway-I"
            data-section-id={'smart-gateway-I'}
            data-section-title={t('title')}
            ref={sectionRef}
        >
            <div className={`sticky ${enter ? 'enter' : ''}`} ref={screenRef}>
                <div className="title ani-1">{t('title')}</div>
                <div className="desc ani-2">{t('desc')}</div>
                <div className="info ani-3">
                    <div className="left">
                        <div className="l-top">
                            <span className="text-1">{t('left1')}</span>
                            <span className="text-2">{t('left2')}</span>
                        </div>
                        <div className="l-bottom">{t('left3')}</div>
                    </div>
                    <div className="center">
                        {curNumber.split('').map((i, idx) => (
                            <div key={idx}>{i}</div>
                        ))}
                    </div>
                    <div className="right">{t('right')}</div>
                </div>
            </div>
        </section>
    );
};

export default I;
